<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="planName" label="计划名"> </el-table-column>
      <el-table-column prop="taskName" label="执行的任务名/任务ID">
        <template slot-scope="scope">
          {{ scope.row.taskName }}[{{ scope.row.taskId }}]
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="执行时间"> </el-table-column>
      <el-table-column label="是否启用计划">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.ste"
            :active-value="1"
            :inactive-value="0"
            @change="changeSwitch(scope.row.id, scope.row.ste)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加广播任务' : '修改广播任务'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="计划名" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="开始执行时间" prop="start_time">
            <el-time-select
              placeholder="起始时间"
              v-model="editOne.start_time"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '24:00',
              }"
            >
            </el-time-select>
          </el-form-item>
          <el-form-item label="执行的任务" prop="task_id">
            <el-select
              placeholder="请选择执行的任务"
              filterable
              v-model="editOne.task_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in devSelect"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import realtimeApi from "@/api/audio/realtime";
import planTaskApi from "@/api/audio/planTask";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入任务名", trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {},
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取任务列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      planTaskApi.planTaskList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getRealtimeList();
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: "",
          task_id: null,
          start_time: "",
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.planName,
          task_id: index.taskId,
          start_time: index.startTime,
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      planTaskApi.planTaskEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      planTaskApi.planTaskAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          planTaskApi.planTaskDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSwitch(id, ste) {
      planTaskApi.planTaskSet({ plan_id: id, ste: ste }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getRealtimeList() {
      realtimeApi
        .realtimeList({
          page: 1,
          pageSize: 100,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data.list;
            let devData = [];
            for (let i = 0; i < resData.length; i++) {
              let devobj = {
                value: resData[i].id,
                label: resData[i].id + "[" + resData[i].name + "]",
              };
              devData[i] = devobj;
            }
            this.devSelect = devData;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
</style>